export const getUrls = () => {

	return {
		simpleText: '/simple-text',
		letters: '/letters',
		
		// external
		externalurls: {
			pcssUrl: 'https://www.pcss.pl/',
			poznanCityUrl: 'https://www.poznan.pl/',
			uamUrl: 'https://amu.edu.pl/',
		},
	};
};